import { render, staticRenderFns } from "./DashboardWidgetCompanyJudgement.vue?vue&type=template&id=87ef4a74&"
import script from "./DashboardWidgetCompanyJudgement.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetCompanyJudgement.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetCompanyJudgement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports